import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2017 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className=" lgl:mt-14 w-full  border-l-[6px] border-l-black border-opacity-30 flex flex-col mt-5 gap-6 flex-grow">
          <ResumeCard
            title="Universitas Dian Nuswantoro Semarang"
            subTitle="Bachelor of Computer Science degree, majoring in Informatics Engineering"
            result="3.78/4.00"
            des={
            <>
              <ul>
                <li>- Divisi IPTEK – Himpunan Mahasiswa Teknik Informatika (HMTI)</li>
                <li>- Program Kampus Merdeka: Studi Independen Bersertifikat (SIB) How To Be An Ideal Top Search ReactJS Front- End Engineer
                Program-Alterra Academy</li>
                <li>- Program KOMINFO: Digital Talent Scholarship Fresh Graduate Academy (DTS FGA) Big Data Using Python – Cisco Networking
                Academy</li>
                <li>- Program KOMINFO: Digital Talent Scholarship Fresh Graduate Academy (DTS FGA) Big Data Using Python – Cisco Networking
                Academy</li>
              </ul><br />
            </>
            }
          />
          <ResumeCard
            title="SMA Negeri 1 Jatisrono Wonogiri"
            subTitle="Senior High School in MIPA "
            result="MIPA"
          />
        </div>
      </div>
      {/* part Two */}

    </motion.div>
  );
};

export default Education;
